import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './ResultPanel.module.sass';

interface ResultPanelProps {
  className?: string;
  sourceFileName?: string;
  frameTime?: string | number;
  children?: React.ReactNode;
}

export function ResultPanel({
  className = undefined,
  children = undefined,
  sourceFileName = undefined,
  frameTime = undefined,
}: ResultPanelProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <aside className={cn(st.Root, className)}>
      <div className={st.Inner}>
        <header className={st.Header}><h5>{t('checks:page.title.result')}</h5></header>
        <div className={st.TopFields}>
          <div className={st.FieldLabel}>{sourceFileName}</div>

          {!!frameTime && (
            <div className={st.Field}>
              <div className={st.FieldLabel}>{t('checks:result panel.frame time')}</div>
              <div className={st.FieldValue}>{frameTime}</div>
            </div>
          )}
        </div>

        <div className={st.Content}>
          {children}
        </div>
      </div>
    </aside>
  );
}
